export default __webpack_public_path__ + "assets/images/3e972685f06c17df40ffd2984e52c6dc.png";